import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=1c9fcc80&scoped=true"
var script = {}
import style0 from "./Label.vue?vue&type=style&index=0&id=1c9fcc80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fcc80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9fcc80')) {
      api.createRecord('1c9fcc80', component.options)
    } else {
      api.reload('1c9fcc80', component.options)
    }
    module.hot.accept("./Label.vue?vue&type=template&id=1c9fcc80&scoped=true", function () {
      api.rerender('1c9fcc80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Label.vue"
export default component.exports